import { AccessRole } from './access.constant';

export const AdminRoles = [
  {
    roleId: AccessRole.SUPER_ADMIN,
    name: 'SuperAdmin',
    desc: 'For Site Administrator (Access to everything)',
  },
  {
    roleId: AccessRole.ADMIN,
    name: 'Admin',
    desc:
      'Generic Admin to include all menu options except for Role Maintenance & Config Settings)',
  },
];
